<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="contact-container">
    <div class="form-section" v-if="!isSubmitted">
      <h2 class="main-title">Fly With Us</h2>
      <p class="main-subheading">
        {{ subheading }}
      </p>
      <br />
      <form @submit.prevent="handleSubmit" class="contact-form">
        <div class="form-group">
          <label for="name">Name*</label>
          <input
            type="text"
            id="name"
            v-model="formData.name"
            placeholder="John Doe"
            required
          />
        </div>
        <div class="form-group">
          <label for="email">Email*</label>
          <input
            type="email"
            id="email"
            v-model="formData.email"
            placeholder="email@example.com"
            required
          />
        </div>
        <div class="form-group">
          <label for="organization">Organization</label>
          <input
            type="text"
            id="organization"
            v-model="formData.organization"
            placeholder="Your Organization Name"
          />
        </div>
        <div class="form-group">
          <label for="message">Message (optional)</label>
          <textarea
            rows="2"
            maxlength="50"
            style="max-block-size: 60px; max-width: 100%"
            id="message"
            v-model="formData.message"
            placeholder="Your message here..."
          ></textarea>
        </div>
        <br />
        <button type="submit" class="contact-submit">Submit</button>
      </form>
    </div>

    <div v-else class="thank-you-section">
      <div class="checkmark-container">
        <img src="@/assets/checkmark-icon.png" class="checkmark" />
      </div>
      <h2 class="thank-you-title">Thank you for reaching out!</h2>
      <p class="thank-you-message">
        We'll get back to you as soon as possible.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactForm",
  props: {
    formData: {
      type: Object,
      required: true,
    },
    submitForm: {
      type: Function,
      required: true,
    },
    showBanner: {
      type: Boolean,
      required: true,
    },
    subheading: {
      type: String,
      default: "Get in touch with us to learn more about live drone tours",
    },
  },
  data() {
    return {
      isSubmitted: false,
    };
  },
  methods: {
    async sendEnquiryEmail(emailData) {
      return fetch("https://skyhost.ai/send-enquiry-mail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(emailData),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log("Enquiry email sent successfully");
          return data;
        })
        .catch((error) => {
          console.error("Error sending enquiry email:", error);
          throw error;
        });
    },
    async handleSubmit() {
      // Immediately show thank you message
      this.isSubmitted = true;

      try {
        const emailData = {
          name: this.formData.name,
          email: this.formData.email,
          organization: this.formData.organization,
          message: this.formData.message,
          subject: `New enquiry from ${this.formData.name} about Remote Outdoor Classes`,
          type: this.formData.type || "general",
        };

        // Send the email in the background
        await this.sendEnquiryEmail(emailData);

        // Call the parent's submitForm method
        this.submitForm();
      } catch (error) {
        console.error("Failed to process form submission:", error);
        // Still call the parent's submitForm method even if email sending fails
        this.submitForm();
      }
    },
  },
};
</script>

<style scoped>
.contact-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 7rem 0rem;
  gap: 5rem;
}

.form-section {
  padding: 3rem 0rem; /* Adjust padding for spacing */
  flex: 1; /* Takes up half of the container */
  max-width: fit-content;
}

.info-section {
  flex: 1; /* Takes up half of the container */
  width: 100%; /* Full width */
  max-height: 650px;
}

.overlay-title {
  font-size: 4rem;
}

.overlay {
  position: relative;
  width: 100%;
  top: -50%;
  left: 0%;
  width: 600px;
  padding: 3rem;
  text-align: left;
  /* opacity: 0.1; */
  /* background-color: #000; */
}

.overlay p {
  line-height: 1.4rem;
}

.banner {
  width: 700px;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
  z-index: -1;
}

.main-title {
  font-size: 3rem; /* Adjusted font size */
  color: #000;
  text-align: center;
}

.main-subheading {
  font-size: 1rem;
  margin: 1rem 0rem;
  color: #464646;
}

.contact-form {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 1.2rem;
  text-align: left;
}

.form-group label {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  color: #555;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #000; /* Focus color */
}

.contact-form div {
  margin-bottom: 1rem;
}

.contact-form label {
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.contact-form input,
.contact-form textarea {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

.contact-form button {
  background-color: #000;
  color: white;
  padding: 12px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  margin-top: 1rem;
}

/* Thank You Message Styles */
.thank-you-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 3rem;
  min-height: 400px;
}

.checkmark-container {
  width: 100px;
  height: 100px;
  margin-bottom: 2rem;
}

.checkmark {
  width: 100%;
  height: 100%;
  stroke-width: 2;
  stroke: #000;
  stroke-miterlimit: 10;
}

.thank-you-title {
  font-size: 2.5rem;
  color: #000;
  margin-bottom: 1rem;
}

.thank-you-message {
  font-size: 1.2rem;
  color: #464646;
  max-width: 500px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .thank-you-section {
    padding: 2rem 1rem;
    min-height: 300px;
  }

  .checkmark-container {
    width: 80px;
    height: 80px;
    margin-bottom: 1.5rem;
  }

  .thank-you-title {
    font-size: 2rem;
  }

  .thank-you-message {
    font-size: 1rem;
  }
}
</style>
